import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { TaskService } from '@autocaller_v2/services/TaskService';

export const table = snakeStore(
  {
    actions: {
      getData: ({ rootState }, params) => {
        const id = rootState.autocaller_v2.campaigns.tasks.campaign_id;
        return TaskService.getList(id, params);
      }
    }
  },
  true
);
